import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import HotArticlesSection from "./components/HotArticlesSection";
import PortalSection from "./components/PortalSection";
import ReviewsSection from "./components/ReviewsSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <HeroSection />
      <CategoryNav />
      <HotArticlesSection />
      <PortalSection />
      <ReviewsSection />
      <CTASection />
    </>
  );
}